document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.getElementById('bh-open-filters');
  const closeBtn = document.getElementById('bh-close-filters');
  const drawer = document.getElementById('bh-filter-drawer');
  const overlay = document.getElementById('bh-filter-overlay');

  if (!openBtn || !drawer || !overlay) return;

  const open = () => {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const close = () => {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  openBtn.addEventListener('click', open);
  overlay.addEventListener('click', close);
  closeBtn?.addEventListener('click', close);
});
document.addEventListener('DOMContentLoaded', () => {
  const range = document.getElementById('bhPriceRange');
  const label = document.getElementById('bhPriceLabel');
  const hiddenInput = document.getElementById('bhPriceMax');

  if (!range || !label || !hiddenInput) return;

  const updatePrice = () => {
    const value = Number(range.value);
    label.textContent = `עד ${value} ₪`;
    hiddenInput.value = value;
  };

  updatePrice();
  range.addEventListener('input', updatePrice);
});
document.querySelector('.bh-clear-filters')?.addEventListener('click', () => {
  const url = new URL(window.location.href);
  url.search = '';
  window.location.href = url.toString();
});
document.body.classList.add('bh-filters-open');
// ובסגירה:
document.body.classList.remove('bh-filters-open');

